module.exports = __webpack_public_path__ + "img/06-0资质2-2.72ee58ef.png";